import styled, { css } from '@xstyled/styled-components';
import LlamaImg from '../llama-circle.svg';
import { Props } from '../LlamaModal';

export const DefaultLlama = styled(LlamaImg)<Props>`
  position: absolute;
  z-index: 1;
  ${p =>
    p.horizontal === 'right'
      ? css`
          bottom: 0px;
          right: 0px;
          margin-bottom: -130px;
        `
      : p.horizontal === 'center'
        ? css`
            left: 70px;
            bottom: -20px;
          `
        : css`
            left: -50px;
            top: 0;
          `}

  @media (max-width: sm) {
    z-index: -1;
    top: 0px;
    right: 50px;
  }
`;
